import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  TextField,
  Typography,
} from "@mui/material";
import { useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import calculatorContainerStyle from "./CalculatorContainerStyle";

function LotSizeCalculator() {
  const { register, handleSubmit } = useForm({
    defaultValues: useMemo(() => {
      return {
        amount: localStorage.getItem("amount") || 0,
        riskPercentage: localStorage.getItem("riskPercentage") || 0,
        pip1: localStorage.getItem("pip1") || 0,
        pip2: localStorage.getItem("pip2") || 0,
      };
    }, []),
  });

  const [riskedAmount, setRiskedAmount] = useState(0);
  const [lot, setLot] = useState(0);

  const onSubmit = (data: any) => {
    try {
      let { amount, riskPercentage, pip1, pip2 } = data;

      localStorage.setItem("amount", amount);
      localStorage.setItem("riskPercentage", riskPercentage);
      localStorage.setItem("pip1", pip1);
      localStorage.setItem("pip2", pip2);

      amount = parseFloat(amount);
      riskPercentage = parseFloat(riskPercentage);
      pip1 = parseFloat(pip1);
      pip2 = parseFloat(pip2);

      const riskedAmount = parseFloat(
        ((amount * riskPercentage) / 100).toFixed(2)
      );
      const lot = parseFloat(Math.abs(riskedAmount / (pip1 - pip2)).toFixed(2));

      setRiskedAmount(riskedAmount);
      setLot(lot);

      localStorage.setItem("lot", lot.toString());
    } catch {}
  };
  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      style={{
        maxWidth: "100vw",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-around",
      }}
    >
      <Box sx={calculatorContainerStyle}>
        <Typography variant="h4" sx={{ mb: 4, textAlign: "center" }}>
          Calculadora de Lotaje de Índices
        </Typography>
        <TextField
          type="number"
          fullWidth
          label="Capital inicial"
          inputProps={{
            step: "any",
          }}
          {...register("amount")}
        />
        <TextField
          type="number"
          fullWidth
          label="Porcentaje de riesgo %"
          inputProps={{
            step: "any",
          }}
          {...register("riskPercentage")}
        />
        <TextField
          type="number"
          fullWidth
          label="Precio de entrada"
          inputProps={{
            step: "any",
          }}
          {...register("pip1")}
        />
        <TextField
          type="number"
          fullWidth
          label="Precio salida"
          inputProps={{
            step: "any",
          }}
          {...register("pip2")}
        />

        <Card sx={{ width: "100%", mt: 4 }}>
          <CardHeader title="Lotaje" />
          <CardContent>
            <TextField
              type="number"
              fullWidth
              disabled
              label="Monto en riesgo"
              value={riskedAmount}
            />
            <TextField
              type="number"
              fullWidth
              disabled
              label="Lotaje"
              sx={{ mt: 1 }}
              value={lot}
            />
          </CardContent>
        </Card>

        <Button fullWidth variant="contained" type="submit">
          Calcular
        </Button>
      </Box>
    </form>
  );
}

export default LotSizeCalculator;
